<template>
  <div class="section basic-section info-banner-base">
    <div class="card">
      <div class="image-base">
        <ul class="banner-list">
          <li
            v-for="(item, idx) in infoBannerListMod"
            :key="idx">
            <a :href="item.url" @click.prevent="onBannerClick(idx)">
              <img :src="item.img_url" :alt="item.memo" @load="onBannerImageLoaded">
            </a>
          </li>
        </ul>
        <div class="copy-text">現在人気急上昇<br>＼占いメニュー一覧へ／</div>
        <div class="counselor-base">
          <img src="/static/img/toppage/lp/bannerIcon_lp3_touwa.png" alt="斗弥" @click.stop="onTagItemClick(3)">
          <img src="/static/img/toppage/lp/bannerIcon_lp4_houen.png" alt="法演" @click.stop="onTagItemClick(4)">
          <img src="/static/img/toppage/lp/bannerIcon_lp1_kurenotori.png" alt="暮れの酉" @click.stop="onTagItemClick(1)">
          <img src="/static/img/toppage/lp/bannerIcon_lp2_kanoucoco.png" alt="叶ここ" @click.stop="onTagItemClick(2)">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/*
暮れの酉：444
叶ここ：445
斗弥：446
法演：436
 */
const TAG_IDS = [null,
  444,
  445,
  446,
  436,
]
export default {
  name: 'InfoBanner',
  props: {
    infoBannerList: {
      type: Array,
      default() {
        return []
      }
    }
  },
  data() {
    return {}
  },
  computed: {
    infoBannerListMod() {
      return this.infoBannerList
    }
  },
  methods: {
    onTagItemClick(val) {
      location.href = this.$handoverParams(`/tag/${TAG_IDS[val]}`)
    },
    onBannerClick(value) {
      location.href = this.$handoverParams(this.infoBannerListMod[value].url)
    },
    onBannerImageLoaded(e) {
      e.target.parentElement.parentElement.style.display = 'block'
    }
  }
}</script>

<style scoped lang="scss">
@import "../../../../sass/commons/commonVariables.scss";
$basic_side_padding: 20px;
$basic_top_padding: 25px;
$basic_bottom_padding: 20px;
.section {
  width: 100%;
  height: auto;
  color: $col_base_font;

  .card {
    width: 100%;
    height: 100%;
    box-shadow: 5px 5px 15px rgba(0, 0, 0, 0.15);
    border-radius: 10px;
    background: transparent;
    padding: 0;
  }

  &.basic-section {
    max-width: 580px;
    margin: auto;
    padding-top: $basic_top_padding;
    padding-bottom: $basic_bottom_padding;
    padding-left: $basic_side_padding;
    padding-right: $basic_side_padding;
  }
}
.info-banner-base {
  background: white;
  .image-base {
    width: 100%;
    // height: 0;
    // padding-top: 130.74%;
    position: relative;
    .main-image {
      width: 100%;
      height: auto;
      display: block;
      position: absolute;
      cursor: pointer;
      top: 0;
      left: 0;
      z-index: 1;
    }
    .counselor-base {
      width: 100%;
      // position: absolute;
      bottom: 0;
      left: 0;
      z-index: 10;
      display: flex;
      justify-content: space-between;
      padding: 0 5% 5%;
      img {
        cursor: pointer;
        display: block;
        width: 23%;
      }
    }
    .banner-list {
      margin: 20px 20px 24px;
      padding: 0;
      & > li {
        list-style: none;
        margin: 0 auto 16px;
        display: none;
        &:last-child { margin-bottom: 0; }
        a {
          display: block;
        }
        img {
          max-width: 100%;
          vertical-align: middle;
        }
      }
    }
    .copy-text {
      font-weight: 600;
      font-size: 14px;
      line-height: 1.43;
      text-align: center;
      margin: 0 0 12px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/partials/InfoBanner.vue